export const DEFAULT_FLASH_MESSAGE_KEY = 'FLASH_MESSAGE';
export const FLASH_EXPIRES_IN = 1; // Keep flash message in cookies in mins
